'use client'

import { isbot } from 'isbot'

// Counts the job page view on the server for the System Overview funnel (/api/job-page-view), under the client of the
// job (FEED#SOURCE), which the dashboard filters by. A crawler hit is not a view, as in sendEventToAnalytics.
export default function countJobPageView(client?: string): void {
  if (isbot(navigator.userAgent)) {
    return
  }
  const url = client ? `/api/job-page-view?${new URLSearchParams({ client })}` : '/api/job-page-view'
  // keepalive: the request still completes when the visitor leaves the page at once
  fetch(url, { cache: 'no-store', keepalive: true }).catch(() => undefined)
}
